module.exports = __webpack_public_path__ + "img/paul-hanaoka-s0XabTAKvak-unsplash.810cffe4.png";